var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }